<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addLinkUrl"
                v-if="flagAdd"
                >新增</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="search-box">
              <el-input placeholder="输入姓名、关健字" v-model="keyword">
                <el-button
                  type="primary"
                  slot="append"
                  icon="el-icon-search"
                  @click="initData"
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称" min-width="150">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyName }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column
              prop="username"
              label="用户名"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="realName"
              label="姓名"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="mobile"
              label="手机"
              min-width="110"
            ></el-table-column>
            <el-table-column
              prop="roleTitle"
              label="角色"
              min-width="110"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="90"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  size="small"
                  type="success"
                  effect="dark"
                  v-if="scope.row.status == 0"
                  >正常</el-tag
                >
                <el-tag
                  size="small"
                  type="warning"
                  effect="dark"
                  v-else-if="scope.row.status == 1"
                  >待验证</el-tag
                >
                <el-tag
                  size="small"
                  type="warning"
                  effect="dark"
                  v-else-if="scope.row.status == 2"
                  >待审核</el-tag
                >
                <el-tag size="small" type="info" effect="dark" v-else
                  >黑名单</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="gmtCreate"
              label="时间"
              width="160"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  @click="linkUrl(scope.row.id)"
                  v-if="flagUpdate"
                ></el-button>
                <span v-if="scope.row.roleType != 2">
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    v-if="flagDel"
                    @click="deleteItem(scope.row.id)"
                  ></el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      flagAdd: false,
      flagDel: false,
      flagDel: false,
      flagUpdate: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "系统用户"
        );
        let obj1 = obj.children.find((obj) => obj.title === "账户管理");
        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }

        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/user/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      if (_this.keyword.length > 0) {
        sendUrl += "&realNameLike=" + encodeURI(_this.keyword);
      }
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = null;
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    addLinkUrl() {
      this.$router.push({ name: "ManagerEdit" });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({ name: "ManagerEdit", query: { id: url } });
    },
    //单项删除
    deleteItem: function (val) {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //执行删除操作
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/cabinet/user/" + val,
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
  },
  created: function () {
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Manager/ManagerList.vue